export default __webpack_public_path__ + "static/media/comfort-control.a3b8eac5.svg";